<template>
  <div class="product-selection-bar">
    <div class="selection-bar__main">
      <div class="selection-bar__info">
        <span class="selection-bar__count">{{ selectedCount }}</span>
        <span class="selection-bar__label">produkte të zgjedhura</span>
        <button type="button" class="selection-bar__link" @click="$emit('clear-selection')">Pastro</button>
      </div>

      <div class="selection-bar__divider"></div>

      <div class="selection-bar__actions">
        <button type="button" class="action-btn" title="Eksporto vetëm rreshtat e zgjedhur (jo të gjitha faqet)" @click="$emit('export-csv')">
          <i class="fa fa-file-excel"></i> Eksporto të zgjedhurat
        </button>
        <button type="button" class="action-btn" :disabled="labelExportLoading" @click="$emit('export-labels')">
          <i class="fa fa-tags"></i> Eksporto etiketat
        </button>
        <button
          type="button"
          class="action-btn"
          :disabled="resyncLoading"
          title="Dërgo të gjitha fushat në Financa 1 dhe Financa 2 (PATCH, ose POST nëse artikulli mungon)"
          @click="$emit('resync-financa')"
        >
          <i class="fa fa-spinner fa-spin" v-if="resyncLoading"></i>
          <i class="fa fa-refresh" v-else></i>
          {{ resyncLoading ? "Duke sinkronizuar..." : "Sinkronizo Financa" }}
        </button>

        <div class="selection-bar__divider"></div>

        <label class="action-toggle" :class="{ 'action-toggle--active': editMode }">
          <input type="checkbox" :checked="editMode" @change="$emit('update:editMode', $event.target.checked)" />
          <i class="fa fa-edit"></i> Ndrysho në grup
        </label>

        <template v-if="editMode">
          <button type="button" class="action-btn action-btn--primary" :disabled="saveLoading" @click="$emit('apply')">
            <i class="fa fa-check"></i> Apliko
          </button>
          <button type="button" class="action-btn action-btn--success" :disabled="saveLoading" @click="$emit('save')">
            <i class="fa fa-spinner fa-spin" v-if="saveLoading"></i>
            <i class="fa fa-save" v-else></i>
            {{ saveLoading ? "Duke ruajtur..." : "Ruaj" }}
          </button>
          <button type="button" class="action-btn" :disabled="saveLoading" title="Kthe cmimin dhe vlerat bazë" @click="$emit('restore')">
            <i class="fa fa-undo"></i>
          </button>
        </template>

        <div class="selection-bar__divider"></div>

        <label class="action-toggle action-toggle--muted" :class="{ 'action-toggle--active': onlySelected }">
          <input type="checkbox" :checked="onlySelected" @change="$emit('update:onlySelected', $event.target.checked)" />
          Shfaq vetëm të zgjedhurat
        </label>
      </div>
    </div>

    <div v-if="editMode" class="selection-bar__bulk-edit">
      <span class="bulk-edit__title">Vlerat për të gjitha të zgjedhurat:</span>
      <div class="bulk-edit__fields">
        <div v-if="showRemoveOffer" class="bulk-field">
          <label>Ka ofertë aktuale</label>
          <label class="action-toggle" :class="{ 'action-toggle--active': removeCurrentOffer }">
            <input type="checkbox" :checked="removeCurrentOffer" @change="$emit('update:removeCurrentOffer', $event.target.checked)" />
            Hiq ofertën aktuale
          </label>
        </div>
        <div v-for="header in editableHeaders" :key="header.field" class="bulk-field">
          <label>{{ header.headerName }}</label>
          <div v-if="header.editable.modules" class="bulk-field__price">
            <select v-if="header.editable.modules.operation" v-model="header.editable.operation_value" class="bulk-input bulk-input--tiny">
              <option value="add">+</option>
              <option value="sub">-</option>
            </select>
            <input v-model="header.editable.value" type="text" class="bulk-input bulk-input--small" />
            <select v-model="header.editable.operation_mode" class="bulk-input bulk-input--tiny">
              <option value="number">#</option>
              <option value="percentage">%</option>
            </select>
          </div>
          <select v-else-if="header.editable.type === 'select'" v-model="header.editable.value" class="bulk-input">
            <option :value="bulkUnchanged">Mos ndrysho</option>
            <option v-if="header.editable.empty" :value="header.editable.empty.id">{{ header.editable.empty.label }}</option>
            <option v-for="option in header.editable.options" :key="option.id" :value="option.id">{{ option.label }}</option>
          </select>
          <input v-else v-model="header.editable.value" :type="header.editable.type || 'text'" class="bulk-input" />
          <div v-if="hidden_columns.includes(header.field)" class="bulk-field__disabled"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const BULK_UNCHANGED = "__mos_ndrysho__";

export default {
  props: {
    selectedCount: { type: Number, default: 0 },
    onlySelected: { type: Boolean, default: false },
    editMode: { type: Boolean, default: false },
    editableHeaders: { type: Array, default: () => [] },
    hidden_columns: { type: Array, default: () => [] },
    labelExportLoading: { type: Boolean, default: false },
    resyncLoading: { type: Boolean, default: false },
    saveLoading: { type: Boolean, default: false },
    removeCurrentOffer: { type: Boolean, default: false },
    entity: { type: String, default: "" },
  },
  emits: [
    "clear-selection",
    "update:onlySelected",
    "update:editMode",
    "update:removeCurrentOffer",
    "apply",
    "save",
    "restore",
    "export-csv",
    "export-labels",
    "resync-financa",
  ],
  data() {
    return { bulkUnchanged: BULK_UNCHANGED };
  },
  computed: {
    showRemoveOffer() {
      return this.entity === "product" || this.entity === "";
    },
  },
};
</script>

<style scoped>
.product-selection-bar {
  background: #fff;
  border: 1px solid #dbeafe;
  border-left: 4px solid #3b82f6;
  border-radius: 6px;
  padding: 0.6rem 0.85rem;
  margin-bottom: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.selection-bar__main {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.65rem;
}

.selection-bar__info {
  display: flex;
  align-items: baseline;
  gap: 0.35rem;
  flex-shrink: 0;
}

.selection-bar__count {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1d4ed8;
  line-height: 1;
}

.selection-bar__label {
  font-size: 0.85rem;
  color: #475569;
}

.selection-bar__link {
  margin-left: 0.35rem;
  background: none;
  border: none;
  color: #64748b;
  font-size: 0.8rem;
  cursor: pointer;
  text-decoration: underline;
}

.selection-bar__link:hover {
  color: #1d4ed8;
}

.selection-bar__divider {
  width: 1px;
  height: 1.5rem;
  background: #e2e8f0;
  flex-shrink: 0;
}

.selection-bar__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.4rem;
  flex: 1;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  border: 1px solid #cbd5e1;
  background: #f8fafc;
  color: #334155;
  border-radius: 5px;
  padding: 0.35rem 0.65rem;
  font-size: 0.8rem;
  cursor: pointer;
  white-space: nowrap;
}

.action-btn:hover:not(:disabled) {
  background: #f1f5f9;
  border-color: #94a3b8;
}

.action-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-btn--primary {
  background: #eff6ff;
  border-color: #3b82f6;
  color: #1d4ed8;
}

.action-btn--success {
  background: #f0fdf4;
  border-color: #22c55e;
  color: #15803d;
}

.action-toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  border: 1px solid #e2e8f0;
  background: #fff;
  border-radius: 5px;
  padding: 0.35rem 0.65rem;
  font-size: 0.8rem;
  color: #64748b;
  cursor: pointer;
  white-space: nowrap;
}

.action-toggle--muted {
  font-size: 0.75rem;
}

.action-toggle--active {
  background: #eff6ff;
  border-color: #93c5fd;
  color: #1d4ed8;
}

.action-toggle input {
  accent-color: #3b82f6;
}

.selection-bar__bulk-edit {
  margin-top: 0.65rem;
  padding-top: 0.65rem;
  border-top: 1px solid #e2e8f0;
}

.bulk-edit__title {
  display: block;
  font-size: 0.75rem;
  color: #64748b;
  margin-bottom: 0.4rem;
}

.bulk-edit__fields {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  gap: 0.75rem;
}

.bulk-field {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 120px;
  flex-shrink: 0;
}

.bulk-field label {
  font-size: 0.7rem;
  color: #64748b;
  font-weight: 600;
}

.bulk-field__price {
  display: flex;
  gap: 0.25rem;
}

.bulk-input {
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  padding: 0.25rem 0.4rem;
  font-size: 0.8rem;
  color: #111;
  background: #fff;
}

.bulk-input--small {
  width: 4rem;
}

.bulk-input--tiny {
  width: 2.5rem;
}

.bulk-field__disabled {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.75);
}
</style>
